import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSearch, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ConfirmationModal from '../../../components/ConfirmationPopUp';
import { useSearchMembersMutation } from '../../../features/authentication/assignApiSlice';
import { useGetAllCoTeachersMutation, useDeleteCoTeacherMutation, useAddCoTeacherMutation}  from '../../../features/authentication/classesApiSlice';
import { useContext, useEffect, useState } from 'react';
import { useClassContext } from '../components/classContext';
import CustomToast from '../../../components/Toast';
import { Col, Container, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap';
import ToggleCheckbox from '../../../components/CheckboxToggle';


const AddCoTeacher = ({isOpen, onClose, coTeachers, setCoTeachers})=>{

  const [searchAllMembers] = useSearchMembersMutation();
  const [getCoTeachers] = useGetAllCoTeachersMutation();
  const [deleteCoTeacher] = useDeleteCoTeacherMutation();
  const [addCoTeacherAPI] = useAddCoTeacherMutation();
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [isEnabled, setIsEnabled] = useState(false);
  const { classId } = useClassContext();
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  const [changesProcessing, setChangesProcessing] = useState(false);
  const [deletingCoTeacherId,setDeletingCoTeacherId] = useState(null);

  const handleSearchInputChange = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    if(debouncedSearchText.length >= 3)
    {
      searchData(debouncedSearchText);
    }
  }, [debouncedSearchText]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);
  
  const getCoTeachersAsync = async (id) => {
    try {
      const coTeachers = await getCoTeachers(id).unwrap();
      setCoTeachers(coTeachers);
    } catch (error) {
      console.log(error);
    }
  };

  const searchData = async (text) => {
    try {
      const options = {
        searchText: text.trim()
      };
      const searchMembersResponse = await searchAllMembers(options).unwrap();
      const filteredMembers = searchMembersResponse.filter(
        searchItem => !coTeachers.some(coTeacher => coTeacher.teacherId === searchItem.studentId)
      );
      setSelectedMembers(filteredMembers);
    } catch (ex) {
      console.log('exception');
    }
  };

  const removeAll = () => {
    const membersSelected = selectedMembers.map((item) => ({ ...item, isSelected: false }));
    setSelectedMembers(membersSelected);
  };

  const addTeachers = () => {
    let selectedCoTeachers= selectedMembers.filter((item) => item.isSelected);
    let addedCoTeachers = coTeachers.slice();

    selectedCoTeachers.forEach((item) => {
      const existingCoTeacher = coTeachers.find(
        (coTeacher) => coTeacher.teacherId === item.studentId
      );
      if (!existingCoTeacher) {
        addedCoTeachers.push({
          name: item.lName+ ' ' +item.fName,
          login: item.login,
          teacherId: item.studentId,
          allowEdit: true,
          isNew: true,
          isChanged:true
        });
      }
    });

    setCoTeachers(addedCoTeachers);

    const filteredMembers = selectedMembers.filter(
      searchResult => !addedCoTeachers.some(coTeacher => coTeacher.teacherId === searchResult.studentId)
    );
    setSelectedMembers(filteredMembers);
  };

  const manageOpenConfirmation = async(teacherId,isNew)=>
  {
    if(isNew)
    {
      var result = coTeachers.filter(item=>item.teacherId !== teacherId);
      setCoTeachers(result);
      return;
    }
    setDeletingCoTeacherId(teacherId);
    setOpenConfirmation(true);
  };
  
  const deleteCoTeacherHandler = async (teacherId) => {
    setChangesProcessing(true);

    let options={
      id:classId,
      teacherId:teacherId
    };
    var response = await deleteCoTeacher(options);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast('You can\'t delete Co-teacher', 'error');
      else
        CustomToast(response.error.data.error, 'error');
      return;
    } 
    var result = coTeachers.filter(item=>item.teacherId !== teacherId);
    setCoTeachers(result);
    CustomToast('Deleted Succesfully', 'success');
    setChangesProcessing(false);
    setOpenConfirmation(false);
  };

  const addCoTeacherHandler = async () => {

    let updatedCoTeachers = coTeachers.filter(item=>item.isChanged == true).map(item=>
    {
      return { teacherId: item.teacherId , allowEdit: item.allowEdit, isNew: item.isNew };
    });

    if(!updatedCoTeachers || updatedCoTeachers.length == 0)
    {
      CustomToast('No changes to update', 'error');
      return;
    }

    setChangesProcessing(true);

    let options={
      id:classId,
      coTeachers: updatedCoTeachers
    };
    var response = await addCoTeacherAPI(options);
    if (response.error) {
      if (response.error.data.errors)
      { 
        CustomToast('Incorrect Co-Teacher Data', 'error');
      }
      else
        CustomToast(response.error.data.error, 'error');
      return;
    }
    CustomToast('Co-Teachers List Updated', 'success');
    getCoTeachersAsync(classId);
    setChangesProcessing(false);
    onClose();
  };

  const selectCheckboxChange = (studentId, event) => {

    var selectedResult = selectedMembers.map((item) => 
      item.studentId === studentId ? { ...item, isSelected: event.target.checked } : item
    );

    setSelectedMembers(selectedResult);
    setIsEnabled(selectedResult.some((item) => item.isSelected));
  };

  const onChangeAllowEdit=(teacherId,allowEdit)=>{
    var selectedResult = coTeachers.map((item) => 
      item.teacherId === teacherId ? { ...item, allowEdit: allowEdit, isChanged:true} : item
    );
    setCoTeachers(selectedResult);
  };

  const handleOnClose = ()=>{
    getCoTeachersAsync(classId);
    onClose();
  };

  return(
    <>
      <Modal isOpen={isOpen} onClose={handleOnClose} titleName={'Add Co-Teachers'} detailHeight={'50%'}>
        <Container>
          <Row>
            <Col>
              <div className="co-teacher-box">
                <p>
                Enter either a login id or user&#39;s name (Last, First), then select from dropdown
                and press add.
                </p>
                <div className="custom-search position-relative mb-3">
                  <FontAwesomeIcon icon={faSearch} />
                  <input
                    type="text"
                    value={searchText}
                    onChange={(e) => handleSearchInputChange(e)}
                    className="form-control"  
                    placeholder='Find a teacher'
                  />
                </div>

                <div className='teacherSearch-wrapper transparent-scroll mb-3'>
                  <div className="h-250">
                    {selectedMembers
                      .map((member, index) => (
                        <div
                          key={index}
                          className="form-check-data d-flex justify-content-between align-items-center mb-3">
                          <label className="form-check-label ms-3" htmlFor="Optionsc">
                            {member.lName + ' ' + member.fName + '('+ member.login +')'} 
                          </label>
                          <input
                            key={member.studentId}
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id={`${index}_option-change`}
                            onChange={(e) => selectCheckboxChange(member.studentId, e)}
                            checked={member.isSelected} 
                          />
                        </div>
                      ))}
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-end gap-2 add-remove-wrapper">
                  <button className="btn btn-castleGray" onClick={removeAll}>
                  Remove All
                  </button>
                  <button className="btn btn-castleWhite" disabled={!isEnabled} onClick={addTeachers}>
                  Add
                  </button>
                </div>
              </div>
            </Col>
            <Col>
              <div className='co-teacherTable-wrapper p-3'>
                <div>
                  <h4 className="secondary-title">{'Co-Teachers'}</h4>
                </div>
                <div className='co-teacherTable transparent-scroll mb-2'>
                  {coTeachers?.length > 0 ? <Table key={'table'} className='reportTable'>
                    <thead className='thead-light'>
                      <tr>
                        <th scope="col" className='fw-medium text-center'>Name</th>
                        <th scope="col" className='fw-medium text-center text-nowrap'>Allow Editing <br/>of your <br/>Co-Taught Class</th>
                        <th scope="col" className='fw-medium text-center text-nowrap'>Remove <br/>Co-Teacher<br/> from Class</th>
                      </tr>
                    </thead>                  
                    <tbody>
                      {coTeachers?.map((item) => (
                        <tr key={'coteacherTR' + item.teacherId}>
                          <td className='text-center'>
                            {item.name + '(' + item.login +')'}
                          </td>
                          <td className='text-center'>
                            <ToggleCheckbox
                              key={'toggleCheck' + item.teacherId}
                              id={'coteacher' + item.teacherId}
                              checked={item.allowEdit}
                              onChange={()=> onChangeAllowEdit(item.teacherId, !item.allowEdit)}
                            />
                          </td>
                          <td className='text-center'>
                            <OverlayTrigger
                              key="rename" badge-pink-light
                              placement="top"
                              overlay={<Tooltip className="custom-tooltip">Remove</Tooltip>}>

                              <button className='action-btn-tile red m-0 mt-2' disabled={changesProcessing}
                                onClick={() => { manageOpenConfirmation(item.teacherId, item.isNew);}}
                              >
                                <FontAwesomeIcon
                                  icon={faTrashCan}
                                />
                              </button>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))
                      }
                    </tbody>                
                  </Table> 
                    :
                    <div>
                      <div className='text-danger'>No Co-Teachers Added</div>
                    </div> 
                  }             
                </div>
              </div>
            </Col>       
          </Row>
          <Row>
            <Col>
              <div className="d-flex justify-content-end mt-3 h-25">
                <button className="btn btn-castleGray me-2" onClick={handleOnClose}>
              Cancel
                </button>
                <button className="btn btn-castleRed" disabled={changesProcessing || !coTeachers ||coTeachers.length == 0} onClick={addCoTeacherHandler}>
              Update
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
      <ConfirmationModal
        titleName={'Delete Co-Teacher'}
        isOpen={openConfirmation}
        onClose={() => setOpenConfirmation(false)}
        onSave={()=>{deleteCoTeacherHandler(deletingCoTeacherId);}}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={'Are you sure you want to remove this co-teacher?'}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
    </>);

};

AddCoTeacher.propTypes={
  isOpen:PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  coTeachers: PropTypes.array,
  setCoTeachers: PropTypes.func
};

export default AddCoTeacher;